// Cross region dev flag for the mutual aid feature
// To be cleaned up once feature is fully released
export const FUSUS_CROSS_REGION_DEV = 'fususCrossRegionDev';
